module.exports = __webpack_public_path__ + "static/media/dropdownEmailIcon.a0f70f16.svg";